import { scopeSubFromDto, scopePlanFromDto, mapSubsToPlans, reducePlans, mapFeatures, filterPlansByTier, createPlansHash } from '@/modules/scope-dto';
import accountService from '@/modules/account-service';
import Vue from 'vue';

const state = {
	plans: [],
	planData: [],
	newPlan: null,
	subscriptionRenews: true,
	planCards: [],
	proPackages: [],
	plansMap: {},
	storedSelection: null,
	currentSubscription: null,
	selectedLicenseExtension: null,
	currentPlanCopy: null,
	reviewPlanCards: null,
	selection: {},
	selectedPackage: '',
	useTrial: true
};
/*
Types of subs for testing
BASE (non tek email)
{
	accountId: "act_covz9k8kp8kmuw1",
	claims: [],
	coupons: [],
	created: "2021-05-28T17:15:48.491Z",
	currentPeriodEnd: "2022-05-28T17:15:51.000+00:00",
	currentPeriodStart: "2021-05-28T17:15:51.000+00:00",
	id: "sub_26ny09kp8l6kq8",
	plan: {id: "pln_scope_app_base", name: "TekScope PC Waveform Analysis Software", interval: "yearly", addOns: []},
	quantity: 1
}
BASE WITH ADDONS (non tek email)
{
	accountId: "act_h0vfi8kf4643tk",
	claims: [],
	coupons: [],
	created: "2020-09-15T16:26:13.992Z",
	currentPeriodEnd: "2021-09-15T16:26:14.000+00:00",
	currentPeriodStart: "2020-09-15T16:26:14.000+00:00",
	id: "sub_4aaii7kf464lk6",
	plan: {
		addOns: ["Multi-Scope Analysis", "PAM3 / Signal Separation / Automotive Ethernet Protocol - Analysis", "SpectrumView Analysis"],
		id: "pln_scope_app_base",
		interval: "yearly",
		name: "TekScope PC Waveform Analysis Software"
	},
	quantity: 1
}
BASE WITH ADDONS INTERNAL
{
	accountId: "act_h0vfi8kf4643tk",
	claims: [],
	coupons: [],
	created: "2020-09-15T16:26:13.992Z",
	currentPeriodEnd: "2021-09-15T16:26:14.000+00:00",
	currentPeriodStart: "2020-09-15T16:26:14.000+00:00",
	id: "sub_4aaii7kf464lk6",
	plan: {
		addOns: ["Multi-Scope Analysis", "PAM3 / Signal Separation / Automotive Ethernet Protocol - Analysis", "SpectrumView Analysis"],
		id: "pln_scope_app_base",
		interval: "free",
		name: "TekScope PC Waveform Analysis Software"
	},
	quantity: 1
}
BASE PREPAID
{
	accountId: "act_covz9k8kp8kmuw1",
	claims: [],
	coupons: [],
	created: "2021-05-28T17:20:42.315+00:00",
	currentPeriodEnd: "2021-06-28T17:20:42.315+00:00",
	currentPeriodStart: "2021-05-28T17:20:42.315+00:00",
	id: "sub_26ny09kp8lcvgr",
	plan: {
		addOns: [],
		id: "pln_scope_app_base",
		interval: "yearly",
		name: "TekScope PC Waveform Analysis Software"
	}
	prepaidCouponId: "cpn_subcode1"
	quantity: 1,
	type: "Prepaid"
}
BASE PREPAID WITH ADDONS
{
	accountId: "act_covz9k8kp8kmuw1",
	claims: [],
	coupons: [],
	created: "2021-05-28T17:20:42.315+00:00",
	currentPeriodEnd: "2021-06-28T17:20:42.315+00:00",
	currentPeriodStart: "2021-05-28T17:20:42.315+00:00",
	id: "sub_26ny09kp8lcvgr",
	plan: {
		addOns: ["Jitter Measurements and Analysis"],
		id: "pln_scope_app_base",
		interval: "yearly",
		name: "TekScope PC Waveform Analysis Software"
	}
	prepaidCouponId: "cpn_subcode1"
	quantity: 1,
	type: "Prepaid"
}
BASE TRIAL [n/a]
BASE TRIAL WITH ADDONS
{
	accountId: "act_covz9k8kp8kmuw1",
	claims: [],
	coupons: [],
	created: "2021-05-28T17:20:42.315+00:00",
	currentPeriodEnd: "2021-06-28T17:20:42.315+00:00",
	currentPeriodStart: "2021-05-28T17:20:42.315+00:00",
	id: "sub_26ny09kp8lcvgr",
	plan: {
		addOns: ["Jitter Measurements and Analysis"],
		id: "pln_scope_app_base",
		interval: "yearly",
		name: "TekScope PC Waveform Analysis Software"
	}
	quantity: 1,
	type: "Trial"
}


STARTER (non tek email)
{
	accountId: "act_15cicl9kppspe3f",
	claims: [],
	coupons: [],
	created: "2021-06-09T19:14:59.444Z",
	currentPeriodEnd: "2022-06-09T19:15:00.000+00:00",
	currentPeriodStart: "2021-06-09T19:15:00.000+00:00",
	id: "sub_1z023ad8kppuq2f0",
	plan: {id: "pln_scope_app_starter", name: "TekScope Starter", interval: "yearly", addOns: []},
	quantity: 1
}
STARTER INTERNAL
{
	accountId: "act_1bk89kppv1tlu",
	claims: [],
	coupons: [],
	created: "2021-06-09T19:26:24.189Z",
	currentPeriodEnd: "2022-06-09T19:26:24.000+00:00",
	currentPeriodStart: "2021-06-09T19:26:24.000+00:00",
	id: "sub_ac9kppv4qre",
	plan: {id: "pln_scope_app_starter", name: "TekScope Starter", interval: "free", addOns: []},
	quantity: 1
}
STARTER PREPAID
{
	accountId: "act_5da4vk9kpgdizdo"
	claims: [],
	coupons: [],
	created: "2021-06-03T04:39:11.143+00:00",
	currentPeriodEnd: "2022-06-03T04:39:11.143+00:00",
	currentPeriodStart: "2021-06-03T04:39:11.143+00:00",
	id: "sub_fm1t8kpgesnxi",
	plan: {id: "pln_scope_app_starter", name: "TekScope Starter", interval: "yearly", addOns: []}
	prepaidCouponId: "cpn_tekscope-starter-b72b7328b5e723bb",
	quantity: 1,
	type: "Prepaid"
}
STARTER TRIAL
{
	accountId: "act_5da4vk9kpgdizdo"
	claims: [],
	coupons: [],
	created: "2021-06-03T04:39:11.143+00:00",
	currentPeriodEnd: "2022-06-03T04:39:11.143+00:00",
	currentPeriodStart: "2021-06-03T04:39:11.143+00:00",
	id: "sub_fm1t8kpgesnxi",
	plan: {id: "pln_scope_app_starter", name: "TekScope Starter", interval: "yearly", addOns: []}
	quantity: 1,
	type: "Trial"
}


PROFESSIONAL
PROFESSIONAL INTERNAL
PROFESSIONAL  PREPAID
PROFESSIONAL  TRIAL
{
	accountId: "act_covz9k8kp8kmuw1",
	claims: [],
	coupons: [],
	created: "2021-05-28T19:24:51.118+00:00",
	currentPeriodEnd: "2021-06-11T19:24:51.118+00:00",
	currentPeriodStart: "2021-05-28T19:24:51.118+00:00",
	id: "sub_5qphi9kp8psizy",
	plan: {id: "pln_scope_app_serialdecode", name: "TekScope Professional Serial Decode", interval: "yearly", addOns: []},
	quantity: 1,
	type: "Trial"
}
ULTIMATE
ULTIMATE INTERNAL
ULTIMATE PREPAID
ULTIMATE TRIAL
*/


const getters = {
	scopeSubscriptions: (state, getters, rootState, rootGetters) => {
		return rootState.subscription.subscriptions && rootState.subscription.subscriptions.filter(sub=> {
			return sub && sub.plan.id.includes('scope');
		}).map(scopeSubFromDto);
	},

	paidOrTrialScopeSubs: (state, getters, rootState, rootGetters) => {
		return getters && getters.scopeSubscriptions && getters.scopeSubscriptions.filter(sub=> {
			return !sub.isPrepaid;
		});
	},

	staticScopeSubs: (state, getters, rootState, rootGetters) => {
		return getters && getters.scopeSubscriptions && getters.scopeSubscriptions.filter(sub=> {
			return sub.isPrepaid || sub.isTrial;
		});
	},

	scopeSubscription: (state, getters) => {
		return getters && getters.scopeSubscriptions && getters.scopeSubscriptions.find(sub=> {
			return !sub.isTrial && !sub.isPrepaid;
		});
	},

	trialScopeSub: (state, getters) => {
		return getters.scopeSubscriptions && getters.scopeSubscriptions.find(sub=> {
			return sub.isTrial;
		});
	},

	prepaidScopeSubs: (state, getters) => {
		return getters.scopeSubscriptions && getters.scopeSubscriptions.filter(sub=> {
			return sub.isPrepaid;
		});
	},

	perpetualScopeSubs: (state, getters) => {
		return getters.scopeSubscriptions && getters.scopeSubscriptions.filter(sub=> {
			return sub.isPerpetual;
		});
	}

};

const mutations = {

	'SET_EXTENSION_OPTIONS':(state, options) => {
		const extensionOptions = options.sort((a,b) => parseInt(a.extensionLength[0]) - parseInt(b.extensionLength[0]));
		Vue.set(state.currentSubscription, 'extensionOptions', extensionOptions);
	},

	'GET_SUBSCRIPTION_SUCCESS': (state, current) => {
		state.getSubscriptionStatus = {
			success: true
		};

		state.currentSubscription = current;
	},

	'SET_SUBSCRIPTION' : (state, current) => {
		state.getSubscriptionStatus = {
			success: true
		};
		if (current && !state.newPlan) { // restoring review screen from another page
			state.subscriptionRenews = current.renews;
		}

		state.currentSubscription = current;
	},

	'SET_PLANS': (state, { plans, proPackages, planCards, plansMap, planData }) => {
		state.plans = plans;
		state.plansMap = plansMap;
		state.planCards = planCards;
		state.proPackages = proPackages;
		state.planData = planData;
	},

	'SET_SELECTION': (state, { selection }) => {
		state.selection = selection;
	},

	'SET_PACKAGE': (state, selectedPackage) => {
		state.selectedPackage = selectedPackage;
	},


	'SET_LICENSE_EXTENSION': (state, selectedExtension) => {
		state.selectedLicenseExtension = selectedExtension;
	},

	'SET_TRIAL_FLAG': (state, useTrial) => {
		state.useTrial = useTrial;
	},

	'SET_NEW_PLAN': (state, plan) => {
		state.newPlan = plan;
	},

	'SET_RENEWAL_FLAG': (state, renews) => {
		state.subscriptionRenews = renews;
	},

	'RESET_STATE': (state) => {
		if (state.currentSubscription) {
			state.subscriptionRenews = state.currentSubscription.renews;
		}
		state.newPlan = null;
		state.currentPlanCopy = null;
		state.reviewPlanCards = null;
	},

	'TEAR_DOWN': (state) => {
		state.currentSubscription = null;
		state.selection = {};
		state.selectedPackage = '';
		state.selectedLicenseExtension = null;
	},

};

function getSubById(subs, subId) {
	return subs && subs.find(sub=> {
		return sub && sub.id === subId;
	});
}

function deepCopy(obj) {
	return JSON.parse(JSON.stringify(obj));
}

const actions = {

	'GET_MAINTENANCE_EXTENSION_OPTIONS': (context, { subId }) => {
		return accountService.getMaintenanceOptions(subId);
	},

	'GET_PLANS_REQUEST' : ({ commit, dispatch, getters, rootGetters }) => {
		return accountService.getPlansV2('scope')
			.then((planData) => {
				dispatch('SET_PLANS', { planData });

				const selectionId = planData.find(plan => plan.active && !plan.isAtSubCountLimit).id;
				const initialSelection = state.plansMap[selectionId];
				// new view populated via cache
				return Promise.resolve(initialSelection);
			});
	},

	'GET_SUBSCRIPTION_REQUEST' : ({ commit, dispatch, getters }, { subId }) => {
		if (state.plans.length) {
			let current;
			let selectionId;

			if (subId) {
				// if subId is passed, show the prepaid sub info
				current =  getSubById(getters.scopeSubscriptions, subId);
				if (!current){
					return Promise.reject(new Error('Invalid Subscription ID'));
				}
				selectionId = current.plan.id;
			} else {
				current = getters.scopeSubscription;
				const currenPlanId = current && current.plan && current.plan.id;
				// this is ridiculous but first check for a trial to select, then current sub and last first active plan item
				selectionId = currenPlanId || state.plans.find(plan => plan.active).id;
			}

			dispatch('SET_PLANS', { planData: state.planData, scopeSubs: current ? [current] : [] });
			commit('SET_SUBSCRIPTION', current);

			if (state.selection.id) {
				// if a selection exists let it be!! this is a restored selection
				return Promise.resolve();
			}

			const initialSelection = state.plansMap[selectionId];
			// new view populated via cache
			return Promise.resolve(initialSelection);
		}

		return accountService.getPlansV2('scope')
			.then((planData) => {

				return dispatch('subscription/GET_TEK_SUBSCRIPTIONS_REQUEST', null, {root:true})
					.then(() => {
						//subId would mean its prepaid so grab from prepaid or trial subs list

						let current;
						let selectionId;

						if (subId) {
							// if subId is passed, show the prepaid sub info
							current =  getSubById(getters.scopeSubscriptions, subId);
							if (!current){
								return Promise.reject(new Error('Invalid Subscription ID'));
							}
							selectionId = current.plan.id;
						} else {
							current = getters.scopeSubscription;
							const currenPlanId = current && current.plan && current.plan.id;
							// first check for current sub then first active plan item
							selectionId = currenPlanId || planData.find(plan => plan.active).id;
						}

						dispatch('SET_PLANS', { planData, scopeSubs: current ? [current] : []});
						commit('SET_SUBSCRIPTION', current);
						// if no current id, fall back to first active plan item
						const initialSelection = state.plansMap[selectionId];

						// new view populated throught this request
						return Promise.resolve(initialSelection);
					});
			})
			.catch(error => {
				return Promise.reject(error);
			});
	},

	'LOAD_SCOPE_SUB_VIEW': (context , { subId }) => {
		return context.dispatch('GET_SUBSCRIPTION_REQUEST', { subId })
			.then((sub) => {
				const currentSub = context.state.currentSubscription;
				// if perpetual get the available extensions, if not just return the sub plan because it will return an error
				if (currentSub.isPerpetual) {
					return context.dispatch('GET_MAINTENANCE_EXTENSION_OPTIONS', { subId })
						.then(maintenanceOptions => {
							context.commit('SET_EXTENSION_OPTIONS', maintenanceOptions);
							return sub;
						});
				} else {
					// only return if sub is not perpetual
					return sub;
				}
			});

	},

	['CHANGE_SUBSCRIPTION_REQUEST']: ({ commit, dispatch, rootGetters, getters }, payload) => {
		return accountService.changeSubscription(payload)
			.then(response => {
				const sub = response?.subscription;
				dispatch('subscription/CHANGE_SUBSCRIPTION_SUCCESS', sub, {root:true});

				commit('SET_SUBSCRIPTION', getters.scopeSubscription);
				return Promise.resolve(sub);
			})
			.catch(error => {
				return Promise.reject(error);
			});
	},

	['ADD_SUBSCRIPTION_REQUEST']: (context, payload) => {
		if (payload.subId) {
			return context.dispatch('CHANGE_SUBSCRIPTION_REQUEST', payload);
		}

		return context.dispatch('ADD_NEW_SUBSCRIPTION', payload);
	},

	['ADD_NEW_SUBSCRIPTION']: ({commit, dispatch, rootGetters, getters}, coupon) => {
		return accountService.addSubscription(coupon)
			.then(response => {
				dispatch('subscription/ADD_SUBSCRIPTION_SUCCESS', response, {root:true});

				commit('SET_SUBSCRIPTION', getters.scopeSubscription);
				return Promise.resolve(response);
			})
			.catch(error => {
				return Promise.reject(error);
			});
	},

	'SET_PLANS' : ({ commit }, { planData, scopeSubs }) => {
		const plansCopy = deepCopy(planData);
		let plans = mapSubsToPlans(plansCopy, scopeSubs || []);

		commit('SET_PLANS', { plans, proPackages: filterPlansByTier(plans, 'professional'), planCards: reducePlans(plans), plansMap: createPlansHash(plans), planData });
	},

	'SET_PREPAID_PLAN' : ({ commit }, { planData, prepaidSub }) => {
		const plansCopy = deepCopy(planData);
		const prepaidPlan = plansCopy.find(plan => plan.id === prepaidSub.plan.id);

		let plans = mapSubsToPlans([prepaidPlan], [prepaidSub]);


		commit('SET_PLANS', { plans, proPackages: filterPlansByTier(plans, 'professional'), planCards: reducePlans(plans), plansMap: createPlansHash(plans), planData });
	},

	'SET_NEW_PLAN' : ({ commit }, plan) => {
		commit('SET_NEW_PLAN', plan);
		commit('SET_TRIAL_FLAG', plan.hasTrial);
	},

	'SET_RENEWAL_FLAG' : ({ commit }, renews) => {
		commit('SET_RENEWAL_FLAG', renews);
	},

	'SET_SELECTION' : ({ commit }, selection) => {
		commit('SET_SELECTION', selection);
	},

	'SET_PACKAGE' : ({ commit }, selectedPackage) => {
		commit('SET_PACKAGE', selectedPackage);
	},

	'SET_LICENSE_EXTENSION' : ({ commit }, selectedExtension) => {
		commit('SET_LICENSE_EXTENSION', selectedExtension);
	},

	'SET_TRIAL_FLAG' : ({ commit }, useTrial) => {
		commit('SET_TRIAL_FLAG', useTrial);
	},

	'RESET_STATE' : ({ commit }) => {
		commit('RESET_STATE');
	},

	'TEAR_DOWN' : ({ commit }) => {
		commit('TEAR_DOWN');
	},

};

// return accountService.getSubscriptions()
// 	.then(response => {
// 		let subs = response.data.subscriptions;
// 		commit(GET_SUBSCRIPTIONS_SUCCESS, subs);
//
// 		if (getters.scopeSubscriptions.length) {
// 			dispatch(SET_MASTER_SCOPE_SUB);
// 		}
//
// 		return Promise.resolve(subs);
// 	})
// 	.catch(error => {
// 		commit(GET_SUBSCRIPTIONS_ERROR);
// 		return Promise.reject(error);
// 	});


export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/scope.js